/**
 * Values for the `autoComplete` prop of `CustomInput` / antd `Input`.
 *
 * These map to the HTML autofill field names (WHATWG HTML §autofill).
 *
 * Only the tokens currently used in the app are listed — add more from the
 * spec as they are needed.
 */
const AUTO_COMPLETE = {
  /** Use on sensitive fields (NRIC/FIN, identifiers). Browsers treat it as a hint and may still autofill. */
  OFF: 'off',

  ADDRESS_LINE2: 'address-line2',
  ADDRESS_LINE3: 'address-line3',
  EMAIL: 'email',
  NAME: 'name',
  ONE_TIME_CODE: 'one-time-code',
  POSTAL_CODE: 'postal-code',
} as const;

export { AUTO_COMPLETE };
